import tick from "../assets/green-tick-teams.svg"
import run_summary from "../assets/run-summary.svg"
import info from "../assets/teams-info.svg"
import {useEffect, useRef, useState} from "react";
import teams_api from "../api/protected/teams"
import {useNavigate} from "react-router-dom";
import expand from "../assets/expand-teams.svg";
import collapse from "../assets/collapse.svg";


const EditTeamLatestSurveyContainer = (props) => {

    const navigate = useNavigate()

    const isDemo = props.isDemo

    const [survey, setSurvey] = useState(null)
    const [scrollTop, setScrollTop] = useState(0)
    const scrollRef = useRef(null);
    const [collapsed, setCollapsed] = useState(false)
    const [showExpiryHover, setShowExpiryHover] = useState(false)
    // No data popups
    const [showNoDataSurvey, setShowNoDataSurvey] = useState(false)

    useEffect(() => {
        if(!props.team_id) return;
        getLatestSurvey()
    }, [props.team_id]);

    useEffect(() => {
        if (!props.survey) return;
        // Prepare participants with completion etc.
        const newParticipants = (props.survey.participants ?? []).map(p => ({
            ...p,
            completion: p.percentage_complete,
        }));

        setSurvey({
            ...props.survey,
            type: props.survey.survey_type,
            point: props.survey.survey_point,
            participants: newParticipants,
        });
    }, [props.survey]);

    const getLatestSurvey = () => {
        if(!props.survey) {
            let response = teams_api.getLatestSurvey(props.team_id, isDemo);
            response.then(response => {
                setSurvey(response.data)
            }).catch(err => console.log(err))
        } else {
            let participants = props.survey.participants
            let new_participants = []
            for (const person of participants) {
                new_participants.push({...person, "completion": person.percentage_complete})
            }
            let s = {
                ...props.survey,
                "type": props.survey.survey_type,
                "point": props.survey.survey_point
            }
            s["participants"] = new_participants
            setSurvey(s)
        }
    }

    const completionAvg = survey?.participants?.length
        ? survey.participants.reduce((total, p) => total + p.completion, 0) / survey.participants.length
        : 0;

    const formatDate = (timestamp) => {
        let current_date = new Date(timestamp * 1000);
        return `${current_date.getDate()}/${current_date.getMonth() + 1}/${current_date.getFullYear()}`
    }

    const handleScroll = (ev) => {
        let handleMax = 193
        let height = 256
        let scrollHeight = ev.target.scrollHeight - height
        let multiplier = 0

        if (ev.target.scrollTop) {
            multiplier = (ev.target.scrollTop / scrollHeight)
        }
        setScrollTop(Math.round(handleMax * multiplier))
    }

    const handleManageClick = (ev, id) => {
        if (!survey) return;
        navigate(`/surveys/${id}?return=true` + (isDemo && isDemo ? '&&demo=True' : ''))
    }

    const handleCollapse = (ev) => {
        if(!ev) return;
        setCollapsed(!collapsed)
    }

    const canShowRunSummary = () => {
    if (!survey || !survey?.participants) return false

        let completedCount = 0;

        for (const p of survey.participants) {
            if (p.completion >= 100) {
                completedCount++;
                if (completedCount >= 2) return true;
            }
        }

        return false;
    }

    return (
        <div className={`edit-team-latest-survey-container ${props.survey ? "survey-page" : ""}`}>
            <div className={`edit-team-latest-survey-left ${collapsed ? "collapsed" : ""}`}>
                {!props.survey ?
                    <>
                        <div className="edit-team-latest-survey-title bold">Latest Survey</div>
                        {!collapsed ?
                            <>
                                <div className="edit-team-latest-survey-divider" style={{width: 346}}/>
                            </> : null
                        }
                    </> : null
                }
                {!collapsed ?
                    <>
                        <div className="edit-team-latest-survey-subtitle bold" style={{marginTop: 30}}>Survey Type</div>
                        <div className="edit-team-latest-survey-light-row">
                            <div className="latest-survey-light-container">
                                <div className={`latest-survey-light ${survey && survey.type === 2 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Lite</div>
                            </div>
                            <div className="latest-survey-light-container">
                                <div className={`latest-survey-light ${survey && survey.type === 1 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Full</div>
                            </div>
                        </div>
                        <div className="edit-team-latest-survey-subtitle bold">Survey Point</div>
                        <div className="edit-team-latest-survey-light-row">
                            <div className="latest-survey-light-container wide">
                                <div className={`latest-survey-light ${survey && survey.point === 1 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Initial</div>
                            </div>
                            <div className="latest-survey-light-container wide">
                                <div className={`latest-survey-light ${survey && survey.point === 2 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Midpoint</div>
                            </div>
                            <div className="latest-survey-light-container wide">
                                <div className={`latest-survey-light ${survey && survey.point === 3 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Endpoint</div>
                            </div>
                            <div className="latest-survey-light-container very-wide">
                                <div className={`latest-survey-light ${survey && survey.point === 4 ? "filled" : ""}`}/>
                                <div className="latest-survey-light-text">Post Engagement</div>
                            </div>
                        </div>
                        <div className="edit-team-latest-survey-divider" style={{width: 346, marginTop: 45}}/>
                        <div className="edit-team-latest-survey-key-value-container">
                            <div className="edit-team-latest-survey-subtitle bold">Number of Participants:</div>
                            <div className="edit-team-latest-survey-value bold">{survey && survey.participants?.length}</div>
                        </div>
                        <div className="edit-team-latest-survey-divider" style={{width: 346, marginBottom: 15}}/>
                        <div className="edit-team-latest-survey-dates-container">
                            <div className="latest-survey-date">
                                <div className="edit-team-latest-survey-subtitle bold">Issue Date</div>
                                <div className="latest-survey-date-value regular"> {survey && formatDate(survey.start_date || (survey.expiry_date - 604800))} </div>
                            </div>
                            <div className="latest-survey-date">
                                <div className="edit-team-latest-survey-expiry-container">
                                    <div className="edit-team-latest-survey-subtitle bold">Expiry Date</div>
                                    <div className="label info-popup">
                                        <img src={info} alt="Info"
                                             onMouseOver={() => setShowExpiryHover(true)}
                                             onMouseLeave={() => setShowExpiryHover(false)}
                                        />
                                        {showExpiryHover ?
                                            <div className="dashboard-roi-title-hover" style={{top: 420, left: 233}}>
                                                <div className="dashboard-roi-title-hover-triangle-outer">
                                                    <div className="dashboard-roi-title-hover-triangle-inner"/>
                                                </div>
                                                <div className="dashboard-roi-title-hover-text regular">
                                                    This is the deadline for survey completion which is included in the survey
                                                    invitation emails and reports. We recommend at least a week for completions.
                                                    Note: This is for information only and does not prevent later responses.
                                                </div>
                                            </div> : null
                                        }
                                    </div>
                                </div>
                                <div className="latest-survey-date-value regular">{survey && formatDate(survey.expiry_date)}</div>
                            </div>
                        </div>
                    </> : null
                }
            </div>
            <div className={`edit-team-latest-survey-right ${collapsed ? "collapsed" : ""}`}>
                <div className="edit-team-latest-survey-title bold">
                    Survey Completion Rate
                    <div className={"edit-team-latest-survey-run-summary-button" + ((!survey || !canShowRunSummary()) ? " no-data" : "")} style={{display: props.survey ? "none" : null}}
                         onClick={ev => handleManageClick(ev, survey?.id)}
                         onMouseOver={()=> setShowNoDataSurvey(true)}
                         onMouseOut={()=> setShowNoDataSurvey(false)}>
                        <div className="edit-team-latest-survey-run-summary-text bold">MANAGE SURVEY</div>
                        <div className="edit-team-latest-survey-run-summary-img">
                            <img src={run_summary} alt="Run summary"/>
                        </div>
                        {showNoDataSurvey && (!survey || !canShowRunSummary()) ?
                            <div className="edit-team-no-data-popup">
                                {!canShowRunSummary() ? "Need 2+ members at 100%" : "No data available"}
                            </div> : null
                        }
                    </div>
                    <div className={`edit-team-latest-survey-collapse ${collapsed ? "collapsed" : ""}`} onClick={handleCollapse}>
                        <img src={collapsed ? expand : collapse} alt={collapsed ? "Show survey details" : "Hide survey details"}/>
                    </div>
                </div>
                {!collapsed ?
                    <>
                        <div className="edit-team-latest-survey-divider" style={{width: 346}}/>
                        <div className="edit-team-latest-survey-right-top-section">
                            <div className="edit-team-latest-survey-right-completion-container">
                                <div className="edit-team-latest-survey-right-completion-text regular">OVERALL COMPLETION</div>
                                <div className="edit-team-latest-survey-right-completion-value bold">{Math.round(completionAvg)}%</div>
                            </div>
                        </div>
                    <div className="edit-team-latest-survey-scroll-container">
                        <div className="edit-team-latest-survey-scroll-area" onScroll={handleScroll}>
                            {survey && survey.participants?.map((participant, idx) => {
                                return (
                                    <div className="edit-team-latest-survey-scroll-row" key={idx}>
                                        <div className="edit-team-latest-survey-scroll-details">
                                            <div className="edit-team-latest-survey-scroll-details-name-container bold">
                                                <div className="scroll-row-text">{participant.name}</div>
                                                <div className="scroll-row-text">{participant.completion}%</div>
                                            </div>
                                            <div className="edit-team-latest-survey-progress-bar-container">
                                                <div className="edit-team-latest-survey-progress-bar-lower"/>
                                                <div className={`edit-team-latest-survey-progress-bar ${participant.completion === 100 ? "complete" : ""}`}
                                                     style={{width: `${participant.completion}%`}}/>
                                            </div>
                                        </div>
                                        <div className="edit-team-latest-survey-scroll-circle">
                                            {participant.completion === 100 ? <img src={tick} alt="Complete"/> : null}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    </> : null
                }
            </div>
        </div>
    )
}


export default EditTeamLatestSurveyContainer